import { registeredUser } from "../registration/registeredUser";
import { organizationStore } from "../organizations/organizations";
import { userStore } from "../users/users";
import { writable, get } from "svelte/store";

export const downLoadSuccess = writable(true);
export const downloading = writable(false);

export function getDocuments(token) {
  downloading.set(true);
  fetch("/api/ehrequests/documents", {
    method: "POST",
    referrer: "",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(getData(token)),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error(response);
      }
      return response;
    })
    .then(async (res) => ({
      filename: "We-ID enterprise aanvraag.zip",
      blob: await res.blob(),
    }))
    .then((resObj) => downloadResponse(resObj))
    .then(() => downloading.set(false))
    .catch((error) => {
      downloading.set(false);
      downLoadSuccess.set(false);
    });
}

function getData(token) {
  return {
    token: token,
    applicant: get(registeredUser),
    organizations: get(organizationStore),
    users: get(userStore),
  };
}

function downloadResponse(resObj) {
  // It is necessary to create a new blob object with mime-type explicitly set for all browsers except Chrome, but it works for Chrome too.
  const newBlob = new Blob([resObj.blob], { type: "application/zip" });

  // MS Edge and IE don't allow using a blob object directly as link href, instead it is necessary to use msSaveOrOpenBlob
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(newBlob);
  } else {
    // For other browsers: create a link pointing to the ObjectURL containing the blob.
    const objUrl = window.URL.createObjectURL(newBlob);

    let link = document.createElement("a");
    link.href = objUrl;
    link.download = resObj.filename;
    link.click();

    // For Firefox it is necessary to delay revoking the ObjectURL.
    setTimeout(() => {
      window.URL.revokeObjectURL(objUrl);
    }, 250);
  }
}
